import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';
import { setJobFormData } from 'src/store/createNewJobSlice';
import { useAppSelector } from 'src/store/store';
import { createSearchRegExp } from 'src/utils/searchUtils';

const BasicJobInfoFields = () => {
  const { regions, jobFormData, jobFormErrors, restrictionFormName } = useAppSelector(
    (state) => state.createNewJobPage,
  );
  const [regionSearchQuery, setRegionSearchQuery] = useState();
  const regionSearchRegExp = createSearchRegExp(regionSearchQuery);
  const matchedRegionOptions = regions
    .map((region) => ({ label: region.name, value: region.name }))
    .filter((option) => !regionSearchQuery || regionSearchRegExp.test(option.label));
  const dispatch = useDispatch();

  return (
    <div>
      <Text type="h300">Basic Job Information</Text>
      <Row widths={'fill'} spacingInset={'500 none 300 none'}>
        <Column spacing="200">
          <Text tag="label" type="b200" color="primary" htmlFor="job-name">
            Job Name
          </Text>
          <Input
            type="text"
            id="job-name"
            placeholder="Enter job name..."
            value={jobFormData?.name}
            onChange={(name) => {
              dispatch(setJobFormData({ ...jobFormData, name }));
            }}
            error={jobFormErrors?.name?.error}
            errorMessage={jobFormErrors?.name?.errorMessage}
          />
        </Column>
      </Row>
      <Row widths={'fill'} spacingInset={'400 none'}>
        <Column spacing="200">
          <Text tag="label" type="b200" color="primary" htmlFor="job-description">
            Description
          </Text>
          <Input
            type="text"
            id="job-description"
            placeholder="Enter description..."
            value={jobFormData?.description}
            onChange={(description) => {
              dispatch(setJobFormData({ ...jobFormData, description }));
            }}
            error={jobFormErrors?.description?.error}
            errorMessage={jobFormErrors?.description?.errorMessage}
          />
        </Column>
      </Row>
      <Row widths={'fill'} spacingInset={'300 none'}>
        <Column spacing="200">
          <Text tag="label" type="b200" color="primary" id="job-region-label">
            Region
          </Text>
          <Select
            aria-labelledby="job-region-label"
            searchQuery={regionSearchQuery}
            onSearch={setRegionSearchQuery}
            placeholder="Select region..."
            value={jobFormData?.region}
            onChange={(region) => {
              dispatch(setJobFormData({ ...jobFormData, region }));
            }}
            error={jobFormErrors?.region?.error}
            errorMessage={jobFormErrors?.region?.errorMessage}
          >
            {matchedRegionOptions.map((option) => (
              <SelectOption label={option.label} value={option.value} key={option.value} />
            ))}
            {!matchedRegionOptions.length ? (
              <Column alignmentVertical="center" spacing="300" spacingInset="500">
                <Text alignment="center">No results</Text>
              </Column>
            ) : null}
          </Select>
        </Column>
        <Column spacing="200">
          <Text tag="label" type="b200" color="primary">
            Form
          </Text>
          <Input disabled={true} value={restrictionFormName}></Input>
        </Column>
      </Row>
      <Row spacingInset={'400 none 300 none'}>
        <Column spacing="200">
          <Toggle
            id="is-active"
            size="large"
            checked={jobFormData?.active}
            onChange={(active) => {
              dispatch(setJobFormData({ ...jobFormData, active }));
            }}
          >
            <Text htmlFor="is-active">Is Active?</Text>
          </Toggle>
        </Column>
        <Column spacing="200">
          <Toggle
            id="is-for-tier-two-plus"
            size="large"
            checked={jobFormData?.isForTierTwoPlusRoles}
            onChange={(isForTierTwoPlusRoles) => {
              dispatch(
                setJobFormData({
                  ...jobFormData,
                  isForTierTwoPlusRoles,
                  jobType: 'Process Path',
                  // reset modified flag if setting isForTierTwoPlusRoles to false
                  isTierTwoPlusJobModified: !isForTierTwoPlusRoles ? false : jobFormData.isTierTwoPlusJobModified,
                  tasks: [],
                }),
              );
            }}
          >
            <Text htmlFor="is-for-tier-two-plus">Is only applicable to T2+?</Text>
          </Toggle>
        </Column>
        {jobFormData?.isForTierTwoPlusRoles && (
          <Column spacing="200">
            <Toggle
              id="is-for-tier-two-plus-modified"
              size="large"
              checked={jobFormData?.isTierTwoPlusJobModified}
              onChange={(isTierTwoPlusJobModified) => {
                dispatch(setJobFormData({ ...jobFormData, isTierTwoPlusJobModified }));
              }}
            >
              <Text htmlFor="is-for-tier-two-plus-modified">Modified?</Text>
            </Toggle>
          </Column>
        )}
      </Row>

      <Divider spacingAfter={'500'} spacingBefore={'450'} />
    </div>
  );
};

export default BasicJobInfoFields;
